export default "__VITE_ASSET__228f1197__"